import React from 'react';
import { getTranslations } from '@translations';
import { Button } from '@components';
import { useHeaderContext } from '../../../../HeaderContext';
import styles from './styles/index.module.scss';

const Help = () => {
  const translations = getTranslations();
  const { platformBaseUrl } = useHeaderContext();
  const url = translations('header.reinsurance.url');

  return (
    <div className={styles.help}>
      <Button
        tag="a"
        href={`${platformBaseUrl}${url}`}
        className={styles.helpButton}
        target="_blank"
        data-qa="helpMeCta"
      >
        {translations('header.reinsurance.button')}
      </Button>
    </div>
  );
};

Help.displayName = 'Help';

export default Help;
